/*
 * Cordial-IA-2026-08-02 - Compteur du panier dans le header (bug post-go-live
 * constate par Anthony : ajout via nos flux cordial -> la bulle de l'icone
 * panier restait a son etat serveur, aucun feedback visuel hors tiroir).
 * CAUSE : le vendor ne met a jour la bulle (.cart-item-count-header--quantity,
 * theme.js onCartUpdate) que sur SON CustomEvent 'wetheme-cart-update'
 * (dispatche par theme.updateCartCount dans son propre flux d'ajout). Nos flux
 * (grille saveurs, compose, trio, cadeaux au seuil, retrait coffret) passent
 * par l'eventBus du theme ('update:cart:drawer' & co) que la bulle n'ecoute pas.
 * PONT : on ecoute les events panier de l'eventBus et on re-emet l'event vendor
 * avec un panier complet. Si le payload recu est deja un panier (item_count
 * present, cas /cart/update.js), zero requete ; sinon GET /cart.js debounce.
 */
(() => {
  const ROUTES = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const dispatch = (cart) => {
    if (!cart || typeof cart.item_count !== 'number') return;
    document.documentElement.dispatchEvent(new CustomEvent('wetheme-cart-update', { detail: { cart } }));
  };

  let timer = null;
  const refresh = (payload) => {
    if (payload && typeof payload.item_count === 'number') {
      dispatch(payload);
      return;
    }
    clearTimeout(timer);
    timer = setTimeout(async () => {
      try {
        const res = await fetch(ROUTES.replace(/\/$/, '') + '/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
        if (res.ok) dispatch(await res.json());
      } catch (e) { /* silencieux : la bulle garde son dernier etat */ }
    }, 150);
  };

  const subscribe = () => {
    if (!window.eventBus) return false;
    window.eventBus.on('cart:added', refresh);
    window.eventBus.on('update:cart:drawer', refresh);
    window.eventBus.on('render:cart:drawer', () => refresh());
    return true;
  };

  const init = () => {
    // eventBus peut ne pas etre pret immediatement : on retente brievement
    // (meme motif que cordial-gift-threshold.js).
    if (!subscribe()) {
      let tries = 0;
      const iv = setInterval(() => {
        tries += 1;
        if (subscribe() || tries > 20) clearInterval(iv);
      }, 250);
    }
  };

  // 15/10/2026 : la pastille compte les articles PAYANTS seulement (cadeaux de palier,
  // emballage Trio et jigger promo a 0 EUR exclus), comme "N bouteilles" du tiroir.
  // Passe APRES le handler du theme (theme.js onCartUpdate ecrit item_count).
  document.documentElement.addEventListener('wetheme-cart-update', (e) => {
    const cart = e && e.detail && e.detail.cart;
    if (!cart || !Array.isArray(cart.items)) return;
    const n = cart.items.reduce((s, it) => s + ((it.final_line_price || 0) > 0 ? (it.quantity || 0) : 0), 0);
    setTimeout(() => {
      document.querySelectorAll('.cart-item-count-header--quantity').forEach((el) => {
        el.textContent = n;
        el.classList.toggle('hide', n === 0);
      });
    }, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
